<template>
    <div>
        <!-- BUTTON GROUPING & BUTTON PART LIST-->
        <div class="pa-1">
            <div class=" group">
                <v-flex shrink class="" @click="to('part-list')" v-if="partListBasket.length > 0">
                    <v-btn class="primary" dark>
                        <v-icon left class="subPrimary--text mr-2">checklist</v-icon>
                        <small class="ml-2"> {{'LISTA PARTES'}}</small>
                    </v-btn>
                </v-flex>
                <v-flex v-show="!showing_selected_parts">
                    <v-btn dark color="primary" @click="$emit('switch_group_by')">
                        <v-icon color="white" left>import_export</v-icon>
                        <small class="ml-2">{{ grouped_by === 'manufacturer' ? 'descripción' : 'fabricante'}}</small>
                    </v-btn>
                </v-flex>
            </div>
            <v-divider vertical v-if="!$isPhoneDevice"></v-divider>
        </div>
        <v-divider v-if="partListBasket.length > 0"></v-divider>
        <!-- PART BASKET -->
        <div v-if="partListBasket.length > 0" v-show="!showing_selected_parts">
            <div class="group">
                <div class="mr-4">
                    <v-badge right overlap color="primary" class=" ml-3 mt-3">
                        <span slot="badge">{{ partListBasket.length }}</span>
                        <v-icon>shopping_basket</v-icon>
                    </v-badge>
                </div>
                <div class="group-space">
                    <h4 class="mt-3">PARTES SELECCIONADAS</h4>
                    <v-btn @click="showContent()" icon>
                        <v-icon v-show="this.show === false">expand_more</v-icon>
                        <v-icon v-show="this.show === true">expand_less</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <v-divider v-if="partListBasket.length > 0"></v-divider>
        <!-- IF V-SHOW IS TRUE -->
        <div v-show="show && !showing_selected_parts">
            <v-layout row wrap class="mb-1 ml-3">
                <v-chip v-for="(part, index) in partListBasket" :key="`tag-part-${index}`" color="orange"
                    style="z-index: 0; max-width:auto; max-height:auto;" text-color="white" close
                    @input="TOGGLE_PART_SELECTION(part)">

                    <strong style="z-index: 0; white-space: normal !important; word-wrap: break-word;">
                        {{ part.description.replace(/[, ]+/g, " ") }} / {{
                        part.mfgCode.replace(/,+/g, " ") }} / {{
                        part.partNum.replace(/,+/g, " ") }}
                    </strong>
                </v-chip>
            </v-layout>
        </div>
        <v-divider v-if="inSelected.length > 0"></v-divider>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { ReadMoreDirective } from "@/utils/directives";
import jsPDF from 'jspdf';
import autotable from 'jspdf-autotable';
import { debounce, to } from "@/utils/functions";

export default {
    name: "ToolbarDesktop",
    props: {
        grouped_by: {
            type: String,
            required: true
        },
        showing_selected_parts: {
            type: Boolean,
            default: false
        },
        showSelected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: true,
            search: "",
        }
    },
    computed: {
        ...mapState({
            skin: state => state.settings.skin,
            group_list: state => state.parts.group_list,
            groups: state => state.parts.groups,
            groups_interchange: state => state.interchange.groups,
            partListBasket: state => state.parts.partListBasket

        }),
        inSelected() {
            console.log("groups", this.groups);
            let parts = [];

            this.groups.forEach(group => group.parts.forEach(part => part.selected && parts.push(part)));
            this.groups_interchange.forEach(group => group.parts.forEach(part => part.selected && parts.push(part)));
            return parts
        },
        are_there_any_groups_selected() {
            return this.inSelected.length;
        },
    },
    directives: {
        ReadMore: ReadMoreDirective,
    },
    methods: {
        to,
        update_search_string: debounce(function (new_search_string) {
            console.log("Search string updated:", new_search_string);
            this.search = new_search_string;
        }, 163),
        switch_group_by() {
            this.grouped_by = this.grouped_by === 'manufacturer' ? 'description' : 'manufacturer';
        },

        showContent() {
            if (this.show == true)
                this.show = false;
            else
                this.show = true
        },
        ...mapActions({
            TOGGLE_PART_SELECTION: "parts/TOGGLE_PART_SELECTION"
        }),
        printTable() {
            const pdf = new jsPDF();
            autotable(pdf, {
                didDrawCell: data => {
                    // console.log("Data:", data);
                    if (data.section === 'body' && data.column.index === 0 && ((data.row.index % 3) == 1)) {
                        const base64Img = `data:image/jpeg;base64,${this.groups[0].parts[0].thumbnailURL}`;
                        pdf.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10)
                    }
                },
                theme: 'plain',
                headStyles: { textColor: '#969696' },
                columns: [
                    { header: 'MINIATURA', dataKey: 'thumbnail' },
                    { header: 'DESCRIPCIÓN', dataKey: 'description' },
                    { header: 'MFG', dataKey: 'mfg' },
                    { header: '# DE PARTE', dataKey: 'part_number' },
                    { header: 'AÑOS', dataKey: 'year' },
                    { header: 'CANTIDAD POR VEHÍCULO', dataKey: 'quantity' },
                ],
                body: [
                    [{ content: 'BOSCH U.S.A', colSpan: 6, styles: { fillColor: this.skin.primary_color, textColor: 'white' } }],
                    [{ content: '', rowSpan: 2 }, { content: 'Batería', styles: { textColor: this.skin.primary_color } }, { content: 'RBS' }, { content: 'S4-48' }, { content: '98' }, { content: '0' }],
                    [
                        {
                            content: '680CCA/835CA; RESERVE MIN = 120; 70AH A4; A4 QUATTRO; PR-J1D CODE; BATT GASSES NEED TO BE VENTED TO OUTSIDE.; MAINTENANCE FREE; AUTO/LIGHT TRUCK/VAN; OE EXACT FIT REPL; PR= PRODUCTION RUN A PR CODE IS USED TO IDENTIFY THE OPTIONS BUILT INTO A VEHICLE; VEHICLE COMPUTER SYS MUST BE RESET AND BATT REGISTERED USING SCAN TOOL.; OE GROUP: 48; OE CCA: 640 OEM USED VARIOUS SIZE BATTS IN PRODUCTION. CHECK ORIG BATT FOR SIZE AND CORRECT FIT.',
                            // content: 'INFO',
                            colSpan: 5,
                            styles: { fillColor: 'white', textColor: '#969696' }
                        }],
                    [{ content: 'CONTINENTAL BATTERY', colSpan: 6, styles: { fillColor: this.skin.primary_color, textColor: 'white' } }],
                    [{ content: '', rowSpan: 2 }, { content: 'Batería', styles: { textColor: this.skin.primary_color } }, { content: 'CBT' }, { content: 'L3/H6/48AGM' }, { content: '97-98' }, { content: '0' }],
                    [
                        {
                            content: '760CCA/950CA; RESERVE MIN = 140 AGM PLUS; BATT MUST BE VENTED OUTSIDE OF VEHICLE; OE CCA: 570',
                            // content: '1',
                            colSpan: 5,
                            styles: { fillColor: 'white', textColor: '#969696' }
                        }],
                ]
            })
            pdf.save("Part-list.pdf");
        }
    },
};
</script>
<style lang="stylus">
    .group
      display: flex
      flex: 1
    .group-space
      display: flex
      flex: 1
      justify-content: space-between
</style>
